module.exports = __webpack_public_path__ + "img/1_018.4fa40526.jpg";